// @flow
import React from 'react';
import CardThumbnail from 'components/fragments/card/CardThumbnail';
import { dynamicClassName } from 'utils/dynamicClassName';

type Props = {
  url?: string,
  img?: Object,
  title?: string,
  description?: string,
  label?: string,
  hub?: boolean
};

const Bulletin = (props: Props) => {
  const divClassName = dynamicClassName('col col-lg-3');
  props.hub ?
    divClassName.add('col-md-4 mb-6 mb-md-0 mt-md-60')
  : divClassName.add('col-md-6 mb-2 mb-lg-0');
  return (
    <div className={divClassName.build()}>
      <CardThumbnail
        url={props.url}
        backgroundUrl={props.img}
        title={props.title}
        linkLabel={props.label}
        desc={props.description}
      />
    </div>
  );
};

export default Bulletin;
